import React, { Component, Suspense } from 'react';
import { Route, BrowserRouter, Switch } from 'react-router-dom'
import ReactGA from 'react-ga';
import Backdrop from './Components/Backdrop/Backdrop';
import ScrollToTop from './Components/ScrollToTop/ScrollToTop';
import Footer from './Components/Footer/Footer'
import Toolbar from './Components/Toolbar/Toolbar'
import RouteChangeTracker from './Components/RouteChangeTracker/RouteChangeTracker'
import './App.css';

// Lazy-load pages for faster initial load
const Home = React.lazy(() => import('./Pages/Home/Home'))
const About = React.lazy(() => import('./Pages/About/About'))
const Services = React.lazy(() => import('./Pages/Services/Services'))
const Contact = React.lazy(() => import('./Pages/Contact/Contact'))
const OurTeam = React.lazy(() => import('./Pages/OurTeam/OurTeam'))

const TRACKING_ID = "UA-238309252-1"; // OUR_TRACKING_ID

ReactGA.initialize(TRACKING_ID);

class App extends Component {

constructor(props){
   super(props)
   this.state = {
     sideDrawerOpen: false,
     lightboxIsOpen: false,
     done: false,
       }
    }

    drawerToggleClickHandler = () => {
      this.setState((prevState) => {
        return {sideDrawerOpen: !prevState.sideDrawerOpen}
      })
    }

    backdropClickHandler = () => {
      this.setState({sideDrawerOpen: false});
    };

  render(){
    let backdrop

    if(this.state.sideDrawerOpen){
      backdrop = <Backdrop click={this.backdropClickHandler}/>
    }

    return (
      <div className="App">
        <BrowserRouter>
        <RouteChangeTracker />
        <Toolbar drawerClickHandler={this.drawerToggleClickHandler} />
        {backdrop}
          <React.Fragment>
            <ScrollToTop />
            <Suspense fallback={<div className="loading" aria-live="polite">Loading…</div>}>
              <Switch>
                <Route exact path={'/'} component={Home} />
                <Route path={'/about'} component={About} />
                <Route path={'/services'} component={Services} />
                <Route path={'/team'} component={OurTeam} />
                <Route path={'/contact'} component={Contact} />
              </Switch>
            </Suspense>
          </React.Fragment>
          <Footer/>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;